import api from '../api/account.js'
import auth from '../utils/auth.js'
import qs from 'qs'
import router from '../router'

export default {
 

  checkIP (state) {
    api.getUserLocation().then(res => {
      if (res.data.State === 1) {
        state.userLocationCode = res.data.Value
      }
    }
    )
  },

  testPlatform (state) {
    if (window.top === window.self) {
      state.platform = 'Web'
    } else if (window.top !== window.self && location.href.includes('cumulus')) {
      state.platform = 'LegendHill'
    } else {
      state.platform = 'Facebook'
    }
  },
  loggingStatus (state) {
    api.getLoginUserInfo({
      version: Math.random()
    }).then(res => {
      let base = location.href.includes('staging')
        ? 'https://staging-games.' + window.location.host.split('.')[1] + '.com/'
        : 'https://games.' + window.location.host.split('.')[1] + '.com/'
  
      if (res.data.State === 1 && res.data.Value.IsLogined) {
        if (!location.href.includes('reset')) {
          if (!res.data.Value.IsBindLz) {
            router.push({ path: '/username' })
          } else if (!res.data.Value.IsBindAvatar) {
            router.push({ path: '/avatar' })
          } else {
            const redirectTo = qs.parse(window.location.search, { ignoreQueryPrefix: true }).r

            state.isLogin = true
            if (redirectTo) {
              window.location.href = redirectTo
            } else {
              let IEVersion = IE()
              if (IEVersion && IEVersion <= 9) {
                window.location.href = base + 'poker-flash' // ie低版本跳转flash版本poker
              } else {
                if (auth.getCookie('rewardUrl')) {
                  window.location.href = base + 'poker/?' + auth.getCookie('rewardUrl')
                } else {
                  window.location.href = base + 'poker'
                }
              }
            }
          }
        }
      }
    })
  },
  faceBookLogin (state) {
    console.log("faceBookLogin")
    FB.login(function (response) {
      if (response.authResponse) {
        if (response.status === 'connected') {
          let userId = response.authResponse.userID
          let accessToken = response.authResponse.accessToken
          let platformNum = 0
          if (accessToken) {
            let baseURL = location.href.includes('staging') ? location.protocol + '//staging-napi.' + window.location.host.split('.')[1] + '.com/' : location.protocol + '//napi.' + window.location.host.split('.')[1] + '.com/'
            const params = {
              accessToken: accessToken,
              userid: userId,
              expiresIn: response.authResponse.expiresIn,
              platform: platformNum
            }
            // referrer
            const r = qs.parse(window.location.search, { ignoreQueryPrefix: true }).r
            if (r) { params.r = r }
            auth.setCookie('userEmail', 'facebook', 30)
            window.location.href = baseURL + 'webapi/page/facebooklogin/FacebookDialogLogin?' + qs.stringify(params)
            
          }
        }
      } else {
        console.log('User cancelled login or did not fully authorize.')
      }
    }, {
      scope: 'email'
    })
  },

 

  googleLogin (state) {
    console.log("googleLogin")
    if(window.googleClient==null){
      window.googleClient = google.accounts.oauth2.initTokenClient({
        client_id: '14460564560-l6ld63amkl8lfo2k73lpt4fot1fmm9r3.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
        callback: (response) => {
          console.log("googleTokenCallback :",response)
          if(response){
            console.log("response")
            let accessToken = response.access_token;
            
            if (accessToken) {
              console.log("location.href  :"+location.href)
              let baseURL = location.href.includes('staging') ? location.protocol + '//staging-napi.' + window.location.host.split('.')[1] + '.com/' : location.protocol + '//napi.' + window.location.host.split('.')[1] + '.com/'
              const params = {
                accessToken: accessToken
  
                // expiresIn: response.expiresIn,
                // platform: platformNum
              }
              // referrer
              const r = qs.parse(window.location.search, { ignoreQueryPrefix: true }).r
              console.log("response param r: "+r)
              if (r) { params.r = r }
              auth.setCookie('userEmail', 'facebook', 30)
              window.location.href = baseURL + 'webapi/page/googlelogin/GoogleDialogLogin?' + qs.stringify(params)
              console.log("response url :"+window.location.href)
              // window.location.href = 'www.google.com/' + qs.stringify(params)
            }
          }
        }
      });
    }
    
    window.googleClient.requestAccessToken()
  },


  yahooLogin() {
    let baseURL = location.href.includes('staging') ? location.protocol + '//staging-napi.' + window.location.host.split('.')[1] + '.com/' : location.protocol + '//napi.' + window.location.host.split('.')[1] + '.com/'
    let client_id;
    if (location.href.indexOf('staging') !== -1) {
        client_id = 'dj0yJmk9TnZCeXBlT21rNkszJmQ9WVdrOVlrVnZOV05aTVVzbWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PWZh'; //测试
    } else {
        client_id = 'dj0yJmk9TVNkemFCeFFwYWFrJmQ9WVdrOVZWazFTa0ZCVDBNbWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PTMy'; //线上
    }
    
    auth.setCookie('userEmail', 'facebook', 30)
    window.location.href="https://api.login.yahoo.com/oauth2/request_auth?"+
    "client_id="+client_id+
    "&response_type=code"+
    "&redirect_uri=" + encodeURIComponent(baseURL+"WebAPI/page/yahoologin/YahooLogin");

  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js